import { DatePickerExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
export class DatePickerDto {
  constructor() {}

  createDatePickerTemplateDTO(template: any): DatePickerExtension.Template {
    const templateObj: any = {};

    templateObj.activeShippingDays = template.activeShippingDays;
    templateObj.geoRules = template.geoRules;
    templateObj.blackoutDatesRules = template.blackoutDatesRules;
    templateObj.restrictionsRules = template.restrictionsRules;
    templateObj.description = template.description;
    templateObj.internalName = template.internalName;
    templateObj.label = template.label;
    templateObj.title = template.title;
    templateObj.placementMode = template.placementMode;
    templateObj.skipFirstAvailableDateSelection = template.skipFirstAvailableDateSelection;

    if (template.deliveryServiceInventoryLocationId) {
      templateObj.deliveryServiceInventoryLocationId = +template.deliveryServiceInventoryLocationId;
    }
    if (+template.firstAvailableDate >= 0) {
      templateObj.firstAvailableDate = +template.firstAvailableDate;
    }

    if (template.firstAvailableDateType) {
      templateObj.firstAvailableDateType = template.firstAvailableDateType;
    }
    if (+template.lastAvailableDate >= 0) {
      templateObj.lastAvailableDate = +template.lastAvailableDate;
    }
    if (template.lastAvailableDateType) {
      templateObj.lastAvailableDateType = template.lastAvailableDateType;
    }
    if (template.geoFenceMethod) {
      templateObj.geoFenceMethod = template.geoFenceMethod;
    }
    if (template.type) {
      templateObj.type = template.type;
    }
    if (template.externalVendors) {
      templateObj.externalVendors = template.externalVendors;
    }

    return templateObj;
  }

  createExampleTemplate() {
    return {
      internalName: 'ice cream shipments',
      type: 'date Field',
      title: 'Schedule delivery in Toronto',
      description: `You'll choose a date and time at checkout`,
    };
  }
}
